import { render, staticRenderFns } from "./LabourRatesRateCard.vue?vue&type=template&id=68c87981&"
import script from "./LabourRatesRateCard.vue?vue&type=script&lang=js&"
export * from "./LabourRatesRateCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports